<template>
    <div class="container-alert inline top-space">
        <div class="alert " :class="`${type}`">
            <div class="alert-icon">
                <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
            </div>
            <div class="content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        type: {
            type: String,
            default: 'info',
        },
    });

</script>